'use strict';

module.exports = isAccept;

function isAccept( header ){
	return header.toLowerCase() === 'accept';
}



/*****************
 ** WEBPACK FOOTER
 ** ./~/pull-fetch-iso/src/is-accept.js
 ** module id = 1765
 ** module chunks = 0
 **/